
export const VerticalFirst = 'Vertical image first';
export const VerticalSecond = 'Vertical image second';
export const VerticalThird = 'Vertical image third';